import { Resources } from 'constants/resources';

import { useNavigateToRoot } from 'hooks/useNavigateToRoot';
import { useStagedDelete } from 'hooks/useStagedDelete';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';
import { CancelButton } from 'shared/mui/Buttons';
import { CardHeader } from 'shared/mui/Card';
import { Dialog } from 'shared/mui/Dialogs';
import { DeleteStageDialogDenyReason } from 'shared/mui/Dialogs/DeleteStageDialog/DeleteStageDialogDenyReason';
import { DeleteStageDialogForm } from 'shared/mui/Dialogs/DeleteStageDialog/DeleteStageDialogForm';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { Method } from 'types/embedded/method';

import { StyledBox } from './MethodsDeleteDialog.styled';

type MethodsDeleteDialogProps = {
  record?: Method;
  open: boolean;
  onClose: () => void;
};

export const MethodsDeleteDialog: React.FC<MethodsDeleteDialogProps> = ({
  record,
  open,
  onClose,
}) => {
  const notify = useNotify();
  const { toRoot } = useNavigateToRoot();
  const closeAndReturn = () => {
    onClose();
    toRoot();
  };
  const { deleteOneRecord, denyDeleteReason, stage } = useStagedDelete({
    record,
    onSuccess: async () => {
      closeAndReturn();
      notify('Метод успешно удален!', { type: 'success' });
      await queryClient.refetchQueries({ queryKey: [Resources.Methods] });
    },
  });

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <StyledBox>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title="Удаление метода"
          titleSize="smallBold"
        />
        <DeleteStageDialogForm
          deleteOneRecord={deleteOneRecord}
          details={
            <Typography>
              Метод <TypographyBold fontSize={16} text={record?.name || ''} /> будет удален без
              возможности восстановления.
            </Typography>
          }
          onClose={onClose}
          open={true}
          stage={stage}
        >
          <DeleteStageDialogDenyReason reason={denyDeleteReason}>
            <CancelButton
              label="Вернуться к списку методов"
              onClick={closeAndReturn}
              variant="outlined"
            />
          </DeleteStageDialogDenyReason>
        </DeleteStageDialogForm>
      </StyledBox>
    </Dialog>
  );
};
